import { useEffect, useState } from 'react';

import { ConfirmDialog, confirmDialog, ConfirmDialogProps } from 'primereact/confirmdialog';

import { BehaviorSubject } from 'rxjs';
import { Button } from 'primereact/button';

const props = new BehaviorSubject(null);
export const ConfirmDialogService = {
  setProps: (data: ConfirmDialogProps) => props.next(data),
  getProps: () => props.asObservable(),
  confirm: (header: string, message: string, accept: () => void) => {
    props.next({
      message,
      header,
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      acceptLabel: 'Đồng ý',
      rejectLabel: 'Không',
      accept
    })
  },
  alert: (header: string, message: any, accept: () => void) => {
    props.next({
      message,
      header,
      icon: 'pi pi-info-circle text-orange-400',
      footer: ({ reject }) => <div className='flex justify-content-between align-items-center'>
        <span>Bạn có muốn tiếp tục lưu không?</span>
        <div>
          <Button label="Không" className="p-button-text" onClick={reject} />
          <Button label="Đồng ý" onClick={() => {
            accept()
            reject()
          }} />
        </div>
      </div>
      ,
    })
  },
  confirmCancel: (accept: () => void) => {
    props.next({
      message: 'Bạn chắc chắn muốn huỷ bản ghi này?',
      header: 'Xác nhận huỷ',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      acceptLabel: 'Huỷ',
      rejectLabel: 'Không',
      accept
    })
  },
  confirmDelete: (accept: () => void) => {
    props.next({
      message: 'Bạn chắc chắn muốn xoá bản ghi này?',
      header: 'Xác nhận xoá dữ liệu',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      acceptLabel: 'Xoá',
      rejectLabel: 'Không',
      accept
    })
  },
  confirmSign: (accept: () => void) => {
    props.next({
      message: 'Bạn có chắc chắn muốn Ký và gửi CQT không?',
      header: ' Ký và gửi CQT',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      acceptLabel: 'Đồng ý',
      rejectLabel: 'Không',
      accept
    })
  },
  confirmSignStatement: (accept: () => void) => {
    props.next({
      message: 'Biên bản đã ký. Thao tác này sẽ làm mất chữ ký số trước đó.',
      header: ' Thông báo',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      acceptLabel: 'Đồng ý',
      rejectLabel: 'Không',
      accept
    })
  },
  showError: (errorCode: string, errors: string) => {
    props.next({
      message: errors,
      header: `Có lỗi xảy ra [CODE ${errorCode}]`,
      icon: 'pi pi-times-circle text-orange-400',
      acceptLabel: 'Đóng',
      rejectClassName: 'hidden'
    })
  },
  showInvalid: (message: string) => {
    props.next({
      message,
      header: `Có lỗi xảy ra`,
      icon: 'pi pi-times-circle text-orange-400',
      acceptLabel: 'Đóng',
      rejectClassName: 'hidden'
    })
  },
  confirmResetPermision: (accept: () => void) => {
    props.next({
      message: 'Bạn chắc chắn khôi phục về toàn quyền dữ liệu ?',
      header: 'Khôi phục quyền',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      acceptLabel: 'Đồng ý',
      rejectLabel: 'Không',
      accept
    })
  },
  confirmSetPermision: (accept: () => void) => {
    props.next({
      message: 'Tài khoản vừa tạo sẽ được sử dụng toàn bộ Ký hiệu hóa đơn, Chữ ký số, Xem hóa đơn của tài khoản khác. /n Bạn có muốn phân quyền chi tiết thêm không? ',
      header: 'Xác nhận tạo quyền',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      acceptLabel: 'Đồng ý',
      rejectLabel: 'Không',
      accept
    })
  },
  confirmReloadAuthorisedCode: (accept: () => void) => {
    props.next({
      message: 'Bạn chắc chắn xác nhận lấy lại mã cơ quan thuế đối với hóa đơn ở trạng thái đã gửi và gửi lỗi?',
      header: 'Lấy lại mã cơ quan thuế',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      acceptLabel: 'Đồng ý',
      rejectLabel: 'Không',
      accept
    })
  },
  confirmChangeTax: (accept: () => void) => {
    props.next({
      message: 'Bạn chắc chắn áp dụng thuế suất cho tất cả mặt hàng đã chọn?',
      header: 'Xác nhận chuyển thuế suất',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      acceptLabel: 'Có',
      rejectLabel: 'Không',
      accept
    })
  },
  confirmUpdateCompanyInfo: (accept: () => void) => {
    props.next({
      message: 'Bạn có chắc chắn muốn cập nhật THÔNG TIN BÊN BÁN TRÊN HÓA ĐƠN theo THÔNG TIN DOANH NGHIỆP đã khai báo?',
      header: 'Cập nhật thông tin bên bán',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      acceptLabel: 'Có',
      rejectLabel: 'Hủy bỏ',
      accept
    })
  },
  confirmAdjustMachineInvoice: (accept: () => void, reject?: () => void) => {
    props.next({
      style: { width: "450px" },
      message:
        "Theo Điểm c, Khoản 1, Điều 10 Thông tư 91/2026/TT-BTC, Trường hợp hóa đơn điện tử đã lập sai là hóa đơn điện tử từ máy tính tiền thì người bán lập hóa đơn THAY THẾ cho hóa đơn đã lập sai.\nBạn có muốn tiếp tục ĐIỀU CHỈNH hoá đơn này không?",
      header: "Cảnh báo",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      acceptLabel: "Có",
      rejectLabel: "Không",
      accept,
      reject,
    });
  },
};

export const AppConfirmDialog = () => {

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    ConfirmDialogService.getProps().subscribe((props) => {
      if (props) {
        confirmDialog(props);
      }
    });
  }, []);

  return <ConfirmDialog visible={visible} onHide={() => setVisible(false)} />
}
